module.exports = __webpack_public_path__ + "static/media/taufiq.e12a51ab.jpg";